<template>
	<section class="newsletter-section align-center">
		<div class="border-lines" />
		<div class="row">
			<div class="columns column12">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />

				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://dedijketelg.us18.list-manage.com/subscribe/post?u=7f1d92ee6ef0a73e5157dd433&id=0687a69542&f_id=00222ee2f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<div id="mc_embed_signup_scroll" style="width: 100%">
							<div class="mc-field-group newsletter-form">
								<input
									id="mce-EMAIL"
									type="email"
									value=""
									name="EMAIL"
									class="required email"
									:placeholder="$t('formEmail')"
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button button-cta"
									:value="button"
								/>
							</div>
							<div>
								<div id="mce-responses" class="clear">
									<div id="mce-error-response" class="response" style="display: none" />
									<div id="mce-success-response" class="response" style="display: none" />
								</div>
								<!-- real people should not fill this in - do not remove this or risk bot signups-->
								<div style="position: absolute; left: -5000px" aria-hidden="true">
									<input
										type="text"
										name="b_7f1d92ee6ef0a73e5157dd433_0687a69542"
										tabindex="-1"
										value=""
									/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<!-- end Mailchimp Signup Form -->
			</div>
		</div>
		<div class="border-lines" />
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: 'Subscribe' },
});
</script>

<style lang="scss" scoped>
.border-lines {
	width: 100%;
	height: 15px;
	margin: 0 0 60px;
	background: url('~/assets/images/border-pattern-red.png') repeat-x center center;

	&:last-child {
		margin: 60px 0 0;
	}
}

.newsletter-section {
	padding: 75px 0;
	background: var(--primary-background-color);
	color: var(--body-color);

	h2:not(.subtitle) {
		border-top: 1px solid var(--cta-color);
		border-bottom: 1px solid var(--cta-color);
		padding: 20px 0;
		margin: 30px 0;
	}

	form {
		margin: 30px auto 0;
		max-width: 520px;
		width: auto;
		display: flex;
		flex-flow: row nowrap;
		justify-content: center;
		align-items: center;
		background: #fff;
		padding: 3px;
		border-radius: 30px;

		input {
			background: #fff;
			font: inherit;
			padding: 15px;
			margin: 4px 0;
			height: 52px;
			border: none;
			width: 100%;
			max-width: 300px;
			vertical-align: top;

			&::placeholder {
				color: var(--cta-color);
			}

			&.button {
				line-height: 22px;
				background: var(--cta-color);
				color: #fff;
				max-width: 200px;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}
</style>
